import React, { ReactElement, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Flex, Logo, Copyright, Whatsapp, Loading, Typography, ConditionalLink } from 'components';
import { useSchool } from 'features/school';
import { useSheets } from 'features/dashboard-new';
import { useBreakpoints } from 'app/hooks';
import { AuthLoginBoxXP } from 'features/auth/components';
import { useResources } from 'features/resources';
// import { useSheets } from 'features/dashboard-new';

// box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.3);
const ContentShadow = styled(Flex)`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  background: var(--color-auth-box-bg);
  flex-direction: column;
  border-radius: 4px;
  height: 100%;

  margin: 0 100px;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 80%;

      ${mediaQueries.tablet} {
        width: 480px;
      }
    `;
  }}
`;

const MailLink = styled(ConditionalLink)`
  color: ${({ theme }) => theme.colors.white}; /* Cor branca para o estado normal e visitado */
  text-decoration: none; /* Remove o sublinhado por padrão */

  &:hover {
    color: ${({ theme }) => theme.colors.white}; /* Mantém a cor branca no hover */
    text-decoration: underline; /* Adiciona sublinhado no hover */
  }

  &:visited {
    color: ${({ theme }) => theme.colors.white}; /* Mantém a cor branca após ser visitado */
  }
`;

const ContentShadowXP = styled(Flex)`
  display: flex;
  height: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  background: var(--color-auth-box-bg);
  flex-direction: column;
  border-radius: 4px;
  margin-right: 30px;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 80%;

      ${mediaQueries.tablet} {
        width: 480px;
      }
    `;
  }}
`;

const AuthLayout = (): ReactElement => {
  const { schoolAlias } = useSchool();
  const { getDashboardUi, usingDashboard } = useSheets();
  // const { pathname } = useLocation();
  const breakpoint = useBreakpoints();
  const {
    schools: { schoolB3, schoolXp, schoolIsNasEscolas, schoolIsFloripaEdu, schoolIsCuritibaEdu, schoolIsGenoveva, schoolIsBiguacuedu },
  } = useResources();

  useEffect(() => {
    getDashboardUi();
  }, []);

  return usingDashboard !== null ? (
    <>
      <Whatsapp />

      <Flex
        className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`}
        width="100vw"
        minHeight="100vh"
        justifyContent="space-between"
        flexWrap="nowrap"
      >
        {schoolIsNasEscolas && (
          <Flex
            width={{
              m: 0,
              d: '100%',
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            backgroundSize="cover"
            backgroundPosition="left bottom"
            backgroundImage={`url(/images/melver-nas-escolas/login-bg.jpeg)`}
            alignItems="center"
            justifyContent="center"
          >
            <></>
          </Flex>
        )}

        {schoolIsGenoveva && (
          <Flex
            width={{
              m: 0,
              d: '100%',
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            backgroundSize="cover"
            backgroundPosition="left bottom"
            backgroundImage={`url(/images/melver-nas-escolas/login-bg.jpeg)`}
            alignItems="center"
            justifyContent="center"
          >
            <></>
          </Flex>
        )}
        {/* 
        {schoolIsFloripaEdu && (
          <Flex
            width={{
              m: 0,
              d: '100%',
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            backgroundSize="cover"
            backgroundPosition="left bottom"
            backgroundImage={`url(/images/floripaedu/loginbg2.png)`}
            alignItems="center"
            justifyContent="center"
          >
            <></>
          </Flex>
        )} */}

        <Flex flexGrow={1} flexDirection="column" flexWrap="nowrap" bg="authBackground">
          <Flex flexDirection="column">
            {/* {pathname.startsWith('/login') && schoolB3 && (
              <Flex bg="primary_400" p={{ m: 2, d: 3 }} flexDirection="column" flexGrow={0} textAlign="center">
                <Typography type="type2" color="dark_350">
                  A plataforma está de cara nova! Por favor, redefina sua senha clicando em “
                  <ConditionalLink to={'/forgot-password'} type="internal">
                    <Typography type="type2" color="dark_350" style={{ fontStyle: 'italic' }}>
                      Esqueci minha senha
                    </Typography>
                  </ConditionalLink>
                  ”.
                </Typography>
              </Flex>
            )} */}

            <Flex as="header" role="banner" flexGrow={0} justifyContent="center" py={{ m: 20, d: 30 }}>
              <Logo dark={schoolB3 || schoolIsNasEscolas || schoolIsFloripaEdu || schoolIsCuritibaEdu || schoolIsGenoveva || schoolIsBiguacuedu} />
            </Flex>
          </Flex>

          <Flex flexDirection="column">
            <Flex justifyContent="center" alignItems="center" flexGrow={0}>
              {schoolXp ? (
                <ContentShadowXP as="main" role="main" mr={6}>
                  <AuthLoginBoxXP />
                </ContentShadowXP>
              ) : null}

              <ContentShadow as="main" role="main">
                <Outlet />
              </ContentShadow>
            </Flex>

            {schoolXp ? (
              <Flex flexGrow={0} justifyContent="center" py={{ m: 20, d: 30 }}>
                <Typography type="type1" color="gray_500" mt={50}>
                  Caso não possua acesso ou tenha algum problema para logar,
                  <br />
                  por favor, entre em contato com:{' '}
                  <MailLink to="mailto:treinamento.uxp@xpi.com.br" type="external" activeStyle={{ color: 'white', textDecoration: 'underline' }}>
                    treinamento.uxp@xpi.com.br
                  </MailLink>
                </Typography>
              </Flex>
            ) : null}
          </Flex>

          <Flex as="footer" role="contentinfo" flexGrow={0} justifyContent="center" py={{ m: 20, d: 30 }}>
            <Copyright />
          </Flex>
        </Flex>

        {schoolB3 && (
          <Flex
            width={{
              m: 0,
              d: 500,
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            flexShrink={0}
            backgroundSize="cover"
            backgroundPosition="center bottom"
            backgroundImage={`url(/images/b3/alth-bg.png)`}
            alignItems="center"
            justifyContent="center"
          >
            <img src="/images/b3/logo.svg" alt="B3 Educação" />
          </Flex>
        )}

        {schoolIsFloripaEdu && (
          <Flex
            width={{
              m: 0,
              d: 500,
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            flexShrink={0}
            backgroundSize="cover"
            backgroundPosition="center bottom"
            // backgroundImage={`url(/images/b3/alth-bg.png)`}
            backgroundColor="#3bc3cc"
            alignItems="center"
            justifyContent="center"
          >
            <img src="/images/floripaedu/loginbg2.png" alt="Melver Educação" />
          </Flex>
        )}
        {schoolIsBiguacuedu && (
          <Flex
            width={{
              m: 0,
              d: 500,
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            flexShrink={0}
            backgroundSize="cover"
            backgroundPosition="center bottom"
            // backgroundImage={`url(/images/b3/alth-bg.png)`}
            backgroundColor="#3bc3cc"
            alignItems="center"
            justifyContent="center"
          >
            <img src="/images/biguacuedu/loginbg.png" alt="Melver Educação" />
          </Flex>
        )}

        {schoolIsCuritibaEdu && (
          <Flex
            width={{
              m: 0,
              d: 500,
            }}
            display={{
              m: 'none',
              d: 'flex',
            }}
            flexGrow={0}
            flexShrink={0}
            backgroundSize="cover"
            backgroundPosition="center bottom"
            // backgroundImage={`url(/images/b3/alth-bg.png)`}
            backgroundColor="#3bc3cc"
            alignItems="center"
            justifyContent="center"
          >
            <img src="/images/curitibaedu/loginbg.png" alt="Melver Educação" />
          </Flex>
        )}
      </Flex>
    </>
  ) : (
    <Loading label="Por favor, aguarde." />
  );
};

export default AuthLayout;
